module.exports = __webpack_public_path__ + "static/media/level-3-anim.33eb2380.gif";